
import { mergeStyles } from 'office-ui-fabric-react';

mergeStyles({
    selectors: {
        ':global(body), :global(html), :global(#root)': {
            margin: 0,
            padding: 0,
            height: '100vh',
        },
        ':global(body)': {
            overflow: 'hidden'
        },
        ':global(::-webkit-scrollbar)': {
            width: '8px',
            height: '8px',
        },
        ':global(::-webkit-scrollbar-track)': {
            background: '#eeeeee',
            borderRadius: '2em'
        },
        ':global(::-webkit-scrollbar-thumb)': {
            background: '#BBBBBB',
            borderRadius: '4px'
        },
        ':global(::-webkit-scrollbar-thumb:hover)': {
            background: '#696969'
        }
    }
});

export const theme = {
};

